export default "__VITE_ASSET__BEy8rDpT__"